import { atom } from 'recoil';

import ProjectEditingStep from '../../../../entity/ProjectEditingStep';

export const workflowStepsAtom = atom<Array<ProjectEditingStep>>({
  key: 'projectWorkflowAtom',
  default: [],
});
